import React, { useState } from "react";
import {
  Button,
  Card,
  Modal,
  TextField,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

function Add() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    address: "",
    latitude: "",
    longitude: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleClose();
    console.log("Submitted address:", { ...formValues });
    // Reset form values
    setFormValues({
      name: "",
      description: "",
      address: "",
      latitude: "",
      longitude: "",
    });
  };

  return (
    <>
      <Card
        variant="outlined"
        onClick={handleOpen}
        sx={{
          cursor: "pointer",
          height: 120,
          padding: "30px",
          textAlign: "center",
        }}
      >
        <div>
          <AddCircleOutlineIcon />
          <Typography variant="h6" component="h5">
            Add Address
          </Typography>
        </div>
      </Card>

      {/* Add Address Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          className="form-modal"
          sx={{
            padding: 2,
            margin:2,
            backgroundColor: "white",
            borderRadius: 2,
            
          }}
        >
          <Typography variant="h5" component="h5" sx={{ marginBottom: 2 }}>
            New Delivery Address
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={formValues.name}
              onChange={handleInputChange}
              className="mb20"
              sx={{ marginBottom: 2 }}
            />
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={formValues.description}
              onChange={handleInputChange}
              className="mb20"
              sx={{ marginBottom: 2 }}
            />
            <TextField
              fullWidth
              label="Address"
              name="address"
              value={formValues.address}
              onChange={handleInputChange}
              className="mb20"
              sx={{ marginBottom: 2 }}
            />
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Latitude"
                  name="latitude"
                  value={formValues.latitude}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Longitude"
                  name="longitude"
                  value={formValues.longitude}
                  onChange={handleInputChange}
                />
              </Grid>
            </Grid>

            <Button
              fullWidth
              variant="contained"
              type="submit"
              color="primary"
              sx={{ marginTop: 3 }}
            >
              Add New Address
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
}

export default Add;
